var lowerCase = require('lower-case')

/**
 * Check if a string is lower case.
 *
 * @param  {String}  string
 * @param  {String}  [locale]
 * @return {Boolean}
 */
module.exports = function (string, locale) {
  return lowerCase(string, locale) === string
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/is-lower-case/is-lower-case.js
 ** module id = 277
 ** module chunks = 1
 **/